export const PrayerCard = ({ id, hebrew, transliteration, english, notes }) => (
  <>
    <div className="border hairline bg-parchment p-8 sm:p-12">
      <p dir="rtl" lang="he" data-testid={`${id}-hebrew`} className="font-serif text-3xl leading-[1.8] text-ink sm:text-4xl">
        {hebrew}
      </p>
      <p
        data-testid={`${id}-transliteration`}
        className="mt-8 font-mono text-[12px] uppercase leading-relaxed tracking-[0.14em] text-terracotta"
      >
        {transliteration}
      </p>
      <p data-testid={`${id}-english`} className="mt-8 font-serif text-2xl italic leading-snug text-ink sm:text-3xl">
        “{english}”
      </p>
    </div>
    <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-3">
      {notes.map((x) => (
        <div key={x.k} className="border-t hairline pt-4">
          <p className="font-serif text-lg text-ink">{x.k}</p>
          <p className="mt-1.5 text-sm leading-relaxed text-ink-soft">{x.v}</p>
        </div>
      ))}
    </div>
  </>
);
